// extracted by mini-css-extract-plugin
export default {"container":"LoginFooter--container--af67b3","logo":"LoginFooter--logo--0739d8","footerLinks":"LoginFooter--footerLinks--200433","footerLink":"LoginFooter--footerLink--0af73e"};